import React from 'react';
import { portal, Portal } from '../../../Configs/general';

import ChangeOfOwnershipGDC from './ChangeOfOwnership.GDC';

const ChangeOfOwnership = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ChangeOfOwnershipGDC {...props} />;
    default:
      return <></>;
  }
};

export default ChangeOfOwnership;
